import {
    Box,
    TextField,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
    Button,
    Card,
    Chip,
    InputAdornment,
    useTheme,
    Tabs,
    Tab,
    Grid,
} from '@mui/material';
import BreadCrumb from '../../../common/components/Breadcrumb';
import { Field, FormikProvider, useFormik } from 'formik';
import ReactQuill from 'react-quill';
import './index.css';
import { initialValues, validationSchema } from './FormikData';
import {
    createCircular,
    getAllCircular,
    uploadCircularPdf,
} from '../../../API/Course';
import { Add } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useMemo, useState } from 'react';
import { DataCard } from './DataCard';

export const Circular = () => {
    const breadcrumb = [
        {
            id: '01',
            breadItem: 'Circular',
        },
    ];
    const theme = useTheme();

    const [forBothCircular, setForBothCircular] = useState([]);
    const [forStudentCircular, setForStudenCircular] = useState([]);
    const [forInstructorCircular, setForInstructorCircular] = useState([]);
    const [allResources, setAllResource] = useState([]);
    const [resourceToBeCreated, setresourceToBeCreated] = useState([]);
    const [resourceToBeDeletedId, setResourceToBeDeletedId] = useState([]);
    const [fake, setFake] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);

    const uploadResource = (e) => {
        console.log('all resources', allResources);
        if (allResources?.length >= 3) {
            toast.error('Cannot upload more than 3 resources');
        } else {
            const res = e.target.files[0];
            if (!res) return;
            console.log('resource in field', e.target.files[0]);
            console.log('Resource uploading...', res);

            let data = res.type;

            if (data === 'application/pdf') {
                console.log('all resources', allResources);
                setAllResource([res]);

                setresourceToBeCreated([res]);

                // const existingResource = resourceToBeCreated?.find(
                //     (resource) => resource.name === res.name
                // );

                // if (existingResource) {
                //     toast.error('same file');
                // } else {
                //     setresourceToBeCreated([...resourceToBeCreated, res]);
                // }

                e.target.value = null;
            } else {
                toast.error('Please upload PDF only');
            }
        }
    };

    useEffect(() => {
        getAllCirculars();
        setAllResource([]);
        setresourceToBeCreated([]);
    }, [fake]);

    const handleDeleteResource = (id) => {
        console.log('Delete Id fetched', id);
        allResources.map((resource, index) => {
            console.log('Compare id', resource._id, '||', id);
            if (resource._id === id) {
                console.log('Removing index...', index);
                allResources.splice(index, 1);
                setAllResource(allResources);
                setResourceToBeDeletedId([...resourceToBeDeletedId, id]);
            }
        });
    };

    const [showForm, setShowForm] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            if (!allResources || !allResources?.length) {
                toast.error('Please upload a resource');
                return;
            }
            const res = await createCircular(values, toast);
            console.log('res of create circular', res);

            const uploadResponse = await uploadCircularPdf(
                allResources,
                res?.data?.data._id,
            );
            console.log('upload Response', uploadResponse);
            setFake(!fake);
            resetForm();
            // setAllResource([]);
            setresourceToBeCreated([]);
            setShowForm(false);
        },
    });

    const getAllCirculars = async () => {
        const res = await getAllCircular();
        console.log('res', res);
        setForBothCircular(res?.data?.circularForBoth);
        setForInstructorCircular(res?.data?.instructorCirculars);
        setForStudenCircular(res?.data?.studentCirculars);
        setAllResource(res?.data?.resource);
    };
    const modules = useMemo(() => {
        return {
            toolbar: [
                [{ header: '1' }, { header: '2' }, { font: [] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [
                    { list: 'ordered' },
                    { list: 'bullet' },
                    { indent: '-1' },
                    { indent: '+1' },
                ],
                ['link', 'image', 'video'],
                ['clean'],
            ],
            clipboard: {
                matchVisual: false,
            },
        };
    }, []);
    return (
        <>
            <Box px={14}>
                <Box>
                    <BreadCrumb breadItems={breadcrumb} />
                </Box>
                <Box display="flex" justifyContent="flex-end" my={1}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowForm(!showForm)}
                    >
                        Add Circular
                    </Button>
                </Box>
                {showForm && (
                    <Box
                        maxWidth="md"
                        display="flex"
                        flexDirection="column"
                        gap={2}
                        mb={4}
                    >
                        <FormikProvider value={formik}>
                            <form
                                onSubmit={formik.handleSubmit}
                                style={{
                                    display: 'flex',
                                    gap: '24px',
                                    flexDirection: 'column',
                                }}
                            >
                                <TextField
                                    fullWidth
                                    name="agenda"
                                    label="Agenda"
                                    value={formik.values.agenda}
                                    // onChange={formik.handleChange}
                                    onChange={(e) => {
                                        const trimmedValue =
                                            e.target.value.replace(/^\s+/, ''); // Trim spaces before any character
                                        formik.handleChange(e);
                                        formik.setFieldValue(
                                            'agenda',
                                            trimmedValue,
                                        );
                                    }}
                                    error={
                                        formik.touched.agenda &&
                                        Boolean(formik.errors.agenda)
                                    }
                                    helperText={
                                        formik.touched.agenda &&
                                        formik.errors.agenda
                                    }
                                />
                                <Box
                                    sx={{
                                        '& .ql-toolbar.ql-snow': {
                                            borderColor:
                                                formik.touched.description &&
                                                formik.errors.description
                                                    ? `#CA0000 !important`
                                                    : `${theme.palette.divider} !important`,
                                        },
                                        '& .ql-container': {
                                            borderBottomLeftRadius: '12px',
                                            borderBottomRightRadius: '12px',
                                            minHeight: '200px',
                                            fontSize: '1rem',
                                            borderColor:
                                                formik.touched.description &&
                                                formik.errors.description
                                                    ? `#CA0000 !important`
                                                    : `${theme.palette.divider} !important`,
                                            backgroundColor: '#fff',
                                        },
                                        '& .ql-toolbar': {
                                            borderTopLeftRadius: '12px',
                                            borderTopRightRadius: '12px',
                                            borderColor: `${theme.palette.divider} !important`,
                                            backgroundColor:
                                                theme.palette.grey[100],
                                        },
                                    }}
                                >
                                    <Field name="description">
                                        {({ field }) => (
                                            <ReactQuill
                                                placeholder="Describe what students will learn in this course..."
                                                theme="snow"
                                                name="description"
                                                value={field.value}
                                                onChange={field.onChange(
                                                    field.name,
                                                )}
                                                modules={modules}
                                            />
                                        )}
                                    </Field>
                                </Box>
                                {formik.touched.description &&
                                    Boolean(formik.errors.description) && (
                                        <Typography
                                            variant="caption"
                                            color="error"
                                            sx={{ mt: 0.5, pl: 1 }}
                                        >
                                            {formik.errors.description}
                                        </Typography>
                                    )}
                                <Box>
                                    <TextField
                                        label="Resources"
                                        disabled
                                        fullWidth
                                        name="pdf"
                                        variant="outlined"
                                        style={{
                                            marginBottom: '20px',
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {console.log(
                                                        'allResources',
                                                        allResources,
                                                    )}
                                                    {allResources?.map(
                                                        (resource, index) => (
                                                            <Chip
                                                                style={{
                                                                    maxWidth: 100,
                                                                }}
                                                                id={index}
                                                                label={
                                                                    resource?.name ||
                                                                    resource?.resourseFile
                                                                        ?.split(
                                                                            'resource-',
                                                                        )
                                                                        .pop()
                                                                }
                                                                onDelete={() =>
                                                                    handleDeleteResource(
                                                                        resource?._id,
                                                                    )
                                                                }
                                                                sx={{ ml: 1 }}
                                                            />
                                                        ),
                                                    )}
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <div className="upload-btn-wrapper">
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            color="secondary"
                                                            sx={{
                                                                display: 'flex',
                                                                gap: '4px',
                                                            }}
                                                        >
                                                            <Add
                                                                sx={{
                                                                    color: '#fff !important',
                                                                    fontSize:
                                                                        'large',
                                                                }}
                                                            />
                                                            Upload
                                                        </Button>

                                                        <input
                                                            type="file"
                                                            name="resource"
                                                            accept="application/pdf"
                                                            onChange={
                                                                uploadResource
                                                            }
                                                        />
                                                    </div>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography
                                        variant="body1"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        Type Of User
                                    </Typography>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="Student"
                                            name="role"
                                            value={formik.values.role}
                                            onChange={formik.handleChange}
                                            sx={{ mt: 2 }}
                                            row
                                            required
                                            error={
                                                formik.touched.role &&
                                                Boolean(formik.errors.role)
                                            }
                                            helperText={
                                                formik.touched.role &&
                                                formik.errors.role
                                            }
                                        >
                                            <FormControlLabel
                                                value="student"
                                                control={<Radio />}
                                                label="Student"
                                            />
                                            <FormControlLabel
                                                value="instructor"
                                                control={<Radio />}
                                                label="Instructor"
                                            />
                                            <FormControlLabel
                                                value="both"
                                                control={<Radio />}
                                                label="Both"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>

                                <Box display="flex" justifyContent="flex-start">
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </form>
                        </FormikProvider>
                    </Box>
                )}
                <Box mt={6} mb={2}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 'bold',
                            color: 'text.primary',
                            mb: 0.5,
                        }}
                    >
                        Previously Added Circulars
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>
                        View and filter all previous circulars distributed to
                        different user groups.
                    </Typography>
                </Box>

                <Tabs
                    value={selectedTab}
                    onChange={(e, val) => setSelectedTab(val)}
                    textColor="secondary"
                    indicatorColor="secondary"
                    sx={{
                        mb: 4,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        '& .MuiTab-root': {
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '0.95rem',
                            minWidth: 120,
                        },
                    }}
                >
                    <Tab
                        label={`Students (${forStudentCircular?.length || 0})`}
                    />
                    <Tab
                        label={`Instructors (${
                            forInstructorCircular?.length || 0
                        })`}
                    />
                    <Tab label={`Both (${forBothCircular?.length || 0})`} />
                </Tabs>

                <Box
                    sx={{
                        maxHeight: '65vh',
                        overflow: 'auto',
                        pr: 1,
                        '&::-webkit-scrollbar': {
                            width: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            borderRadius: '4px',
                        },
                    }}
                >
                    {selectedTab === 0 && (
                        <Grid container spacing={3} my={1}>
                            {forStudentCircular?.length > 0 ? (
                                forStudentCircular.map((circular, i) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        key={circular._id || i}
                                    >
                                        <DataCard data={circular} />
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Box
                                        textAlign="center"
                                        py={8}
                                        px={2}
                                        border="1px dashed"
                                        borderColor="divider"
                                        borderRadius="12px"
                                    >
                                        <Typography
                                            color="text.secondary"
                                            variant="body1"
                                        >
                                            No student circulars found.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    )}

                    {selectedTab === 1 && (
                        <Grid container spacing={3} my={1}>
                            {forInstructorCircular?.length > 0 ? (
                                forInstructorCircular.map((circular, i) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        key={circular._id || i}
                                    >
                                        <DataCard data={circular} />
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Box
                                        textAlign="center"
                                        py={8}
                                        px={2}
                                        border="1px dashed"
                                        borderColor="divider"
                                        borderRadius="12px"
                                    >
                                        <Typography
                                            color="text.secondary"
                                            variant="body1"
                                        >
                                            No instructor circulars found.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    )}
                    {selectedTab === 2 && (
                        <Grid container spacing={3} my={1}>
                            {forBothCircular?.length > 0 ? (
                                forBothCircular.map((circular, i) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        key={circular._id || i}
                                    >
                                        <DataCard data={circular} />
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Box
                                        textAlign="center"
                                        py={8}
                                        px={2}
                                        border="1px dashed"
                                        borderColor="divider"
                                        borderRadius="12px"
                                    >
                                        <Typography
                                            color="text.secondary"
                                            variant="body1"
                                        >
                                            No circulars found.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Box>

                <ToastContainer />
            </Box>
        </>
    );
};
